import { render, staticRenderFns } from "./FormPhuongThucThanhToan.vue?vue&type=template&id=0e0fb0d0&scoped=true&"
import script from "./FormPhuongThucThanhToan.vue?vue&type=script&lang=js&"
export * from "./FormPhuongThucThanhToan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0fb0d0",
  null
  
)

export default component.exports